export class Notification {
  constructor() {
    this.errors = []
    this.successes = []
  }

  addError(message) {
    this.errors.push(message)
  }

  addSuccess(message) {
    this.successes.push(message)
  }

  hasErrors() {
    return this.errors.length > 0
  }

  getErrors() {
    return this.errors
  }

  getSuccesses() {
    return this.successes
  }

  clear() {
    this.errors = []
    this.successes = []
  }
}
